import React from 'react';
import { Icon } from 'antd';

const StatusIcon = (props) => {
    return props.status
        ? <Icon aria-label="aria-menu" type="check-circle" className="active-status" />
        : <Icon aria-label="aria-menu" type="close-circle" className="inactive-status" />;
};

export default StatusIcon;